// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3_goo","title":"Info_title__1oqOq","selects":"Info_selects__2Wbt8","requiredAsterisk":"Info_requiredAsterisk__Cx_N7"};